import React, { useState } from "react";
import CustomButton from "../CustomButton";
import CustomInput from "../CustomInput";
import CustomSelect from "../CustomSelect";
import ModalLayout from "../layouts/ModalLayout";
import { useLocation } from "react-router-dom";

interface Props {
  onClose?: () => void;
}

function ForgottenPassword({ onClose }: Props) {
  return (
    <ModalLayout onClose={onClose} width="max-w-[20rem]">
      <div className="w-full flex items-center justify-center ">
        <div className="max-w-md w-full  text-center">
          <div className="text-3xl mb-3">🔐</div>

          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            Forgot your password?
          </h2>

          <p className="text-gray-600 text-sm mb-6">
            Please contact our support team to reset your password.
          </p>

          <div className="bg-gray-50 rounded-xl p-4 space-y-2">
            <p className="text-sm text-gray-700">
              <span className="font-medium">Phone:</span>{" "}
              <a
                href="tel:+917272909873"
                className="text-blue-600 font-semibold">
                +91 72729 09873
              </a>
            </p>
            <p className="text-sm text-gray-700">
              <span className="font-medium">Alt Phone:</span>{" "}
              <a
                href="tel:+917272909873"
                className="text-blue-600 font-semibold">
                +91 93366 74149
              </a>
            </p>

            <p className="text-sm text-gray-700">
              <span className="font-medium">Email:</span>{" "}
              <a
                href="mailto:hr@empedance.com"
                className="text-blue-600 font-semibold">
                hr@empedance.com
              </a>
            </p>
          </div>

          {onClose && (
            <button
              onClick={onClose}
              className="mt-6 text-sm text-gray-500 hover:text-gray-700 underline">
              Close
            </button>
          )}
        </div>
      </div>
    </ModalLayout>
  );
}

export default ForgottenPassword;
